export const BIZ = {
  name: "JSL Dental Repair",
  tagline: "Efficient repairs, brilliant smiles.",
  email: "jsldentalrepair@gmail.com",
  jacob: { name: "Jacob LaCarrubba", role: "Co-founder", phone: "(716) 256-6630", tel: "tel:+17162566630" },
  jonah: { name: "Jonah LaCarrubba", role: "Co-founder", phone: "(716) 381-0305", tel: "tel:+17163810305" },
  areas: ["Buffalo, NY", "Erie", "Rochester"],
  turnaround: "24–72 hours",
  warranty: "6-month warranty on every overhaul · 12 months for $49",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/6627668/pexels-photo-6627668.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  handpieces: "https://images.pexels.com/photos/6528776/pexels-photo-6528776.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  workshop: "https://images.unsplash.com/photo-1776406987595-ba14f3510c07?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  community: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  sharpening: "https://images.pexels.com/photos/31786500/pexels-photo-31786500.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  instruments: "https://images.pexels.com/photos/39596820/pexels-photo-39596820.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  van: "/van-interior.webp",
};

export const BRANDS = [
  "Midwest", "Star Dental", "KaVo", "MK-dent", "NSK", "Bien-Air",
  "Lares", "W&H", "Athena Champion", "Dentex", "Vector",
];

export const PRICING = [
  { item: "Slowspeed Overhaul", detail: "New everything: bearings, o-rings & gaskets — lubed and tested", price: 79.99 },
  { item: "Highspeed Latch Overhaul", detail: "New turbine, o-rings & bearings — lubed and tested", price: 199.99 },
  { item: "Highspeed Push Button Overhaul", detail: "New turbine, o-rings & bearings — lubed and tested", price: 229.99 },
  { item: "Electric Highspeed Overhaul", detail: "Complex micro-motor work", price: 299.99, plus: true },
  { item: "Surgical Handpieces", detail: "Specialty surgical repair", price: 249.99 },
];

export const SERVICE_OPTIONS = [
  "Full overhaul",
  "General maintenance",
  "Repair & assessment",
  "Instrument sharpening",
  "Sales inquiry",
  "Not sure yet",
];

export const DELIVERY_METHODS = [
  "Mobile van — on-site (Buffalo · Erie · Rochester)",
  "Free pickup & delivery (WNY)",
  "Ship in / ship out",
];

export const SYMPTOMS = [
  {
    id: "overheating", label: "Overheating", icon: "flame",
    cause: "Worn bearings or a failing turbine are running hot.",
    fix: "Highspeed Push Button Overhaul", price: 229.99,
    note: "New bearings and turbine bring the temperature — and the noise — back down.",
  },
  {
    id: "slippage", label: "Bur slippage", icon: "magnet",
    fix: "Full overhaul", priceFrom: 199.99,
    cause: "The chuck has worn out and can't grip the bur anymore.",
    note: "Every overhaul includes a brand-new chuck, so this one's covered.",
  },
  {
    id: "lowpower", label: "Low power / torque", icon: "gauge",
    fix: "Full overhaul", priceFrom: 199.99,
    cause: "Turbine wear or an air-pressure leak is starving the head.",
    note: "A fresh turbine and bearings usually restore full torque in a single visit.",
  },
  {
    id: "waterline", label: "Water line clogged", icon: "droplets",
    fix: "General maintenance", call: true,
    cause: "Debris or scale buildup in the water line.",
    note: "A deep clean and lubrication flushes the line — we'll quote it free by phone.",
  },
  {
    id: "vibration", label: "Vibration / noise", icon: "waves",
    fix: "Full overhaul", priceFrom: 199.99,
    cause: "Worn bearings are the usual culprit.",
    note: "Catch it early — bearings that grind today are turbines that seize next week.",
  },
];

export const STEPS = [
  { n: "01", title: "Tell us what's broken", copy: "Call, text, or send the intake form below — list every handpiece and what it's doing." },
  { n: "02", title: "We come to you", copy: "The van parks at your office, we pick up free across WNY, or you ship in from anywhere." },
  { n: "03", title: "Precision overhaul", copy: "OEM-spec parts — bearings, o-rings, gaskets, turbines & chucks. Cleaned, lubricated, tested." },
  { n: "04", title: "Back in your hands", copy: "About an hour on the van. Mail-in orders: once we get the handpieces in, 24–72 hours until they're shipped back to the office. 6-month warranty included." },
];

export const FAQS = [
  {
    q: "How does the mobile van work?",
    a: "We cover Buffalo, Erie and Rochester. The van parks at your office and we repair your equipment right in the parking lot. If we have the parts on board, you get your handpiece back the same day — usually within about an hour. Call or text (716) 256-6630 to check van availability in your area.",
  },
  {
    q: "What does an overhaul include?",
    a: "New everything: bearings, o-rings, gaskets, turbine and chuck — plus a deep clean, lubrication and a full test before it comes back to you. Every overhaul carries a 6-month warranty, extendable to 12 months for $49.",
  },
  {
    q: "How fast will I get my handpiece back?",
    a: "On the van: often within about an hour. Mail-in orders: once we get the handpieces in, it's 24–72 hours until they're shipped back to your office. Free local pickup & delivery runs on the same 24–72 hour clock.",
  },
  {
    q: "Do you service my brand?",
    a: "We service all major brands — Midwest, Star, KaVo, MK-dent, NSK, Bien-Air, Lares, W&H, Athena Champion, Dentex, Vector and more. Our parts meet or exceed OEM specifications.",
  },
  { q: "Any discounts?",
    a: "New customers take 15% off their first order — write a note in your request (e.g. \"15% off first order\") and we'll apply it. We also run loyalty rewards for ongoing service, and we can usually meet or beat competitor prices." },
  {
    q: "How do I get my handpieces to you?",
    a: "Three ways: flag the mobile van, use our free local pickup & delivery around Buffalo/WNY, or ship in / ship out from anywhere in the country. The intake form below tells us exactly what's coming.",
  },
];